import React from 'react'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import Groups2Icon from '@mui/icons-material/Groups2';
import { addTokenToMetaMask, formatPrice } from '../helper/functions';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import swapIcon from '../img/plus.png';
import { AOMZ_IMG, contract, DEFAULT_CHAIN, DTC_IMG, SYMBOL } from '../helper/constant';

export default function MyWallet({ accStats }) {
    return (
        <div className='col-sm-12 col-md-5 mt-4 mt-md-0'>
            <div className='card wallet-card'>
                <div className='card-body'>
                    <h5 className='mb-0 p-2'>My Wallet</h5>
                    <div className='card card-gray mb-2 back5-top'>
                        <div className='card-body'>
                            <div className='d-flex align-items-center'>
                                <div className='icon-box'>
                                    <SwapHorizIcon className='text-primary' fontSize="large" />
                                </div>
                                <div className='ms-3'>
                                    <h6 className='text-white mb-1'>{SYMBOL} Balance</h6>
                                    <h5 className='mb-0 text-primary fs-6'>{accStats.stakeTokenBalance ? formatPrice(accStats.stakeTokenBalance, 9) : 0} {SYMBOL}</h5>
                                </div>
                                <div className='ms-auto' style={{cursor : "pointer"}} onClick={()=>addTokenToMetaMask(contract[DEFAULT_CHAIN].TOKEN_ADDRESS , 'USDT' , 18 , AOMZ_IMG )}>
                                    <img src={swapIcon} alt='swap' height="24px" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card card-gray mb-2 back6-top'>
                        <div className='card-body'>
                            <div className='d-flex align-items-center'>
                                <div className='icon-box'>
                                    <AccountBalanceWalletIcon className='text-primary' fontSize="large" />
                                </div>
                                <div className='ms-3'>
                                    <h6 className='text-white mb-1'>KOM Balance</h6>
                                    <h5 className='mb-0 text-primary fs-6'>{accStats.usdtbal ? formatPrice(accStats.usdtbal, 12) : 0} KOM</h5>
                                </div>
                                <div className='ms-auto' style={{cursor : "pointer"}} onClick={()=>addTokenToMetaMask(contract[DEFAULT_CHAIN].DTC_ADDRESS , 'KOM' , 18 , DTC_IMG )}>
                                    <img src={swapIcon} alt='swap' height="24px" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card card-gray mb-2 back1-top'>
                        <div className='card-body'>
                            <div className='d-flex'>
                                <div className='icon-box'>
                                    <EmojiEventsIcon className='text-primary' fontSize="large" />
                                </div>
                                <div className='ms-3'>
                                    <h6 className='text-white mb-1'>Your Level</h6>
                                    <h5 className='mb-0'>
                                        {
                                            Array.from({ length: 7 }).map((_, index) => {
                                                if (parseInt(index) < parseInt(accStats.userLevel)) {
                                                    return <StarIcon key={index} sx={{ color: "#FCD535" }} fontSize="large" />;
                                                } else {
                                                    return <StarBorderIcon key={index} className='text-primary' fontSize="large" />;
                                                }
                                            })
                                        }
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card card-gray mb-2 back2-top'>
                        <div className='card-body'>
                            <div className='d-flex'>
                                <div className='icon-box'>
                                    <LightbulbIcon className='text-primary' fontSize="large" />
                                </div>
                                <div className='ms-3'>
                                    <h6 className='text-white mb-1'>Referral Earnings</h6>
                                    <h5 className='mb-0 text-primary fs-6'>{accStats.rewardRef ? formatPrice(accStats.rewardRef, 10) : 0} USDT</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card card-gray mb-2 back3-top'>
                        <div className='card-body'>
                            <div className='d-flex'>
                                <div className='icon-box'>
                                    <Groups2Icon className='text-primary' fontSize="large" />
                                </div>
                                <div className='ms-3'>
                                    <h6 className='text-white mb-1'>Your Team Level</h6>
                                    <h5 className='mb-0 text-primary fs-6'>{accStats.team ? formatPrice(accStats.team, 10) : 0} </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
